// @flow
import React, { PureComponent } from 'react'
import RangeDatepicker from '../../shared/range.datepicker'
import classNames from 'classnames'
import _ from 'lodash'
import styled, { type StyledComponent } from 'styled-components'

const DatepickerInput: StyledComponent<Object, any, any> = styled.input`
  &:disabled {
    color: #545454 !important;
    border-color: #ccc !important;
  }
`

type Props = {|
  onChange: Function,
  disabled?: ?boolean,
  data: Object,
  className?: string,
  name?: string
|}

export default class Datepicker extends PureComponent<Props> {
  dateRangeElement: any
  componentDidMount() {
    const dataRange = new RangeDatepicker(this.dateRangeElement)

    dataRange.setup()
    dataRange.subscribeOnValueChange((value) => this.onChange(value))
  }

  onChange(value: string) {
    this.props.onChange(value)
  }

  render() {
    const { data, disabled, className, name } = this.props

    const dataProps = data ? _.mapKeys(data, (value, key) => `data-${key}`) : {}

    return (
      <DatepickerInput
        autoComplete="off"
        disabled={disabled}
        type="datepicker"
        name={name}
        className={classNames('date-input', className)}
        {...dataProps}
        ref={(el) => {
          this.dateRangeElement = el
        }}
      />
    )
  }
}
